module.exports = __webpack_public_path__ + "static/media/kid-buildingg.a1a352ad.jpg";